import React from 'react';
import { useSelector } from 'react-redux';
import { Save, X } from 'lucide-react';
import { useLanguage } from '../../hooks/useLanguage';
import { getDeclarationSummaryTranslation } from '../../hooks/useLanguage';
import { useDeclarationSummary } from '../../hooks/useDeclarationSummary';
import toast from 'react-hot-toast';
import { getMainTranslation } from '../../hooks/useLanguage';

export const SaveCancelButtons = () => {
  const [isSpanish] = useLanguage();
  const extractedData = useSelector((state) => state.documents.extractedData);
  const activeTabId = useSelector(state => state.tabs?.activeTabId);
  const activeTabIsDirty = useSelector(state => {
    const tabsState = state.tabs;
    if (tabsState && tabsState.activeTabId && tabsState.tabs && tabsState.tabs[tabsState.activeTabId]) {
      return tabsState.tabs[tabsState.activeTabId].isDirty || false;
    }
    return false;
  });
  const globalIsDirty = useSelector(state => state.documents.isDirty);
  const isDirty = activeTabIsDirty || globalIsDirty;

  const {
    saveChanges: originalSaveChanges,
    cancelChanges
  } = useDeclarationSummary(extractedData);

  // Wrap saveChanges to show toast notification
  const saveChanges = () => {
    const result = originalSaveChanges();
    if (result?.success === false) {
      toast.error(getMainTranslation('fixAllRequiredBeforeSave', isSpanish));
      return;
    }
    toast.success(getMainTranslation('changesSaved', isSpanish));
  };

  const handleCancelChanges = () => {
    cancelChanges();
    toast.success(getMainTranslation('changesCancelled', isSpanish));
  };

  // Only show buttons if there's data and it's dirty
  if (!isDirty || !extractedData) {
    return null;
  }

  return (
    <div className="flex gap-2 mr-4">
      <button
        className="truncate bg-red-50 rounded-full flex items-center py-2 px-4 gap-2 hover:bg-red-100 transition-colors h-10"
        onClick={handleCancelChanges}
        title={isSpanish ? "Cancelar Cambios" : "Cancel Changes"}
      >
        <X className="stroke-red-500 size-4" />
        <span className="text-red-500 text-xs font-medium">
          {getDeclarationSummaryTranslation('cancel', isSpanish)}
        </span>
      </button>
      <button
        className="truncate bg-default rounded-full flex items-center py-2 px-4 gap-2 hover:opacity-90 transition-opacity h-10"
        onClick={saveChanges}
        title={isSpanish ? "Guardar Cambios" : "Save Changes"}
      >
        <Save className="size-4 stroke-white" />
        <span className="text-white text-xs font-medium">
          {getDeclarationSummaryTranslation('save', isSpanish)}
        </span>
      </button>
    </div>
  );
};

